import Link from 'next/link';
import styles from './TestEds.module.scss';

export const SertInstall = () => {
    return (
        <div className={styles.container}>
            <div className={styles.panel}>
                <h1>Установка сертификатов используя КриптоПРО</h1>

                <p>
                    Для установки личного сертификата электронной подписи (ЭП) и
                    корневого сертификата удостоверяющего центра (УЦ) подключите
                    к USB-порту Вашего компьютера полученный в УЦ
                    flash-носитель, который содержит ключи Вашей электронной
                    подписи.
                </p>

                <ol>
                    <li>
                        Откройте программу <strong>КриптоПро CSP</strong>.
                        <img
                            src="/assets/dummy-data/instructions/open_csp.gif"
                            alt="Откройте программу КриптоПро CSP"
                            title="Откройте программу КриптоПро CSP"
                        />
                    </li>
                    <li>
                        На вкладке <strong>Сервис</strong> нажмите{' '}
                        <strong>Посмотреть сертификаты в контейнере</strong>.
                        <img
                            src="/assets/dummy-data/instructions/show_certs_in_container.gif"
                            alt="Откройте список доступных сертификатов в контейнере"
                            title="Откройте список доступных сертификатов в контейнере"
                        />
                    </li>
                    <li>
                        В появившемся окне нажмите <strong>Обзор</strong>.
                        <img
                            src="/assets/dummy-data/instructions/browse_certs.gif"
                            alt='Нажмите "Обзор"'
                            title='Нажмите "Обзор"'
                        />
                    </li>
                    <li>
                        Выберите ключевой контейнер, и нажмите{' '}
                        <strong>OK</strong>.
                        <img
                            src="/assets/dummy-data/instructions/choose_eds.gif"
                            alt='Выберите подпись и нажмите "OK"'
                            title='Выберите подпись и нажмите "OK"'
                        />
                    </li>
                    <li>
                        Нажмите <strong>Далее</strong>.
                        <img
                            src="/assets/dummy-data/instructions/cert_choice.gif"
                            alt="Подтвердите выбор сертификата"
                            title="Подтвердите выбор сертификата"
                        />
                    </li>
                    <li>
                        В окне с информацией о сертификате нажмите{' '}
                        <strong>Установить</strong>.
                        <img
                            src="/assets/dummy-data/instructions/install_cert.gif"
                            alt="Установите сертификат"
                            title="Установите сертификат"
                        />
                    </li>
                    <li>
                        После успешной установки корневого сертификата Вы
                        увидите окно с текстом:
                        <q>
                            <i>
                                Сертификат был установлен в хранилище
                                &lquot;Личные&rquot; текущего пользователя
                            </i>
                        </q>
                        . Нажмите <strong>ОК</strong>.
                        <img
                            src="/assets/dummy-data/instructions/confirm_installation.gif"
                            alt="Подтвердите результат установки"
                            title="Подтвердите результат установки"
                        />
                    </li>
                    <li>
                        В окне с информацией о сертификате нажмите{' '}
                        <strong>Свойства</strong>.
                        <img
                            src="/assets/dummy-data/instructions/open_cert_props.gif"
                            alt="Откройте свойства сертификата"
                            title="Откройте свойства сертификата"
                        />
                    </li>
                    <li>
                        На вкладке <strong>Путь сертификации</strong> дважды
                        кликните по первому сертификату в списке.
                        <br />
                        Как правило в названии этого сертификата указано
                        наименование УЦ, выдавшего ЭП.
                        <img
                            src="/assets/dummy-data/instructions/open_uc_cert.gif"
                            alt="Откройте сертификат Вашего УЦ"
                            title="Откройте сертификат Вашего УЦ"
                        />
                    </li>
                    <li>
                        В окне с информацией о корневом сертификате УЦ нажмите
                        <strong>Установить сертификат</strong>.
                        <img
                            src="/assets/dummy-data/instructions/install_uc_cert.gif"
                            alt="Установите сертификат УЦ"
                            title="Установите сертификат УЦ"
                        />
                    </li>
                    <li>
                        В мастере импорта сертификатов нажмите{' '}
                        <strong>Далее</strong>.
                        <img
                            src="/assets/dummy-data/instructions/next_install_uc.gif"
                            alt='Нажмите "Далее"'
                            title='Нажмите "Далее"'
                        />
                    </li>
                    <li>
                        Выберите пункт{' '}
                        <strong>
                            Поместить все сертификаты в следующее хранилище
                        </strong>
                        и нажмите <strong>Обзор</strong>.
                        <img
                            src="/assets/dummy-data/instructions/open_stores.gif"
                            alt="Откройте список доступных хранилищ"
                            title="Откройте список доступных хранилищ"
                        />
                    </li>
                    <li>
                        В списке хранилищ выберите{' '}
                        <strong>Доверенные корневые центры сертификации</strong>
                        , после чего нажмите <strong>ОК</strong>.
                        <img
                            src="/assets/dummy-data/instructions/choose_trusted.gif"
                            alt='Выберите "Доверенные корневые центры сертификации"'
                            title='Выберите "Доверенные корневые центры сертификации"'
                        />
                    </li>
                    <li>
                        В мастере импорта сертификатов нажмите{' '}
                        <strong>Далее</strong>.
                        <img
                            src="/assets/dummy-data/instructions/finish_import.gif"
                            alt="Завершите импорт сертификата"
                            title="Завершите импорт сертификата"
                        />
                    </li>
                    <li>
                        Нажмите <strong>Готово</strong>.
                        <img
                            src="/assets/dummy-data/instructions/import_finish.gif"
                            alt="Завершите импорт сертификата"
                            title="Завершите импорт сертификата"
                        />
                    </li>
                    <li>
                        В окне с предупреждением подтвердите установку
                        сертификата нажав <strong>Да</strong>.
                        <img
                            src="/assets/dummy-data/instructions/accept_installation.gif"
                            alt="Подтвердите установку сертификата"
                            title="Подтвердите установку сертификата"
                        />
                    </li>
                    <li>
                        В окне успешного завершения импорта нажмите{' '}
                        <strong>ОК</strong>.
                        <img
                            src="/assets/dummy-data/instructions/accept_finish_import.gif"
                            alt="Подтвердите завершение импорта"
                            title="Подтвердите завершение импорта"
                        />
                    </li>
                </ol>
            </div>
        </div>
    );
};
